module.exports = __webpack_public_path__ + "static/img/copyright-policy-300x300.8c57d594.gif";